import { createContext, useContext, useState, useCallback } from "react";
import { translations, CURRENCIES } from "@/lib/i18n";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("erp_lang") || "tr");

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let node = translations[lang];
      for (const p of parts) {
        node = node?.[p];
      }
      return node ?? path;
    },
    [lang]
  );

  const changeLang = (l) => {
    localStorage.setItem("erp_lang", l);
    setLang(l);
  };

  const formatMoney = useCallback(
    (amount, currency = "TRY") => {
      const c = CURRENCIES[currency] || CURRENCIES.TRY;
      try {
        return new Intl.NumberFormat(c.locale, {
          style: "currency",
          currency: c.code,
          maximumFractionDigits: 2,
        }).format(amount || 0);
      } catch {
        return `${c.symbol}${(amount || 0).toFixed(2)}`;
      }
    },
    []
  );

  return (
    <AppContext.Provider value={{ lang, changeLang, t, formatMoney }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
